import * as Yup from 'yup';
import { Formik } from 'formik';
import React, { Fragment } from 'react';
import { ModalComponent } from 'components/layout/modals/ModalComponent';
import { jobVacancyStore } from '../JobVacancyStore';
import { FormField } from 'components/layout/form-fields/FormField';
import { Dropdown } from 'components/layout/form-fields/inputs/Dropdown';

const ValidationSchema = Yup.object().shape({
	cancelReason: Yup.string().label('Reason').nullable().required(),
	notes: Yup.string().label('Notes')
});

export class JobVacancyFillReason extends ModalComponent {
	getInitialValues() {
		return {
			cancelReason: null,
			notes: ''
		};
	}

	render() {
		return (
			<Formik
				initialValues={this.getInitialValues()}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.create(values);
				}}>
				{formikBag =>
					this.renderModalContainer(formikBag, 'JobVacancyFillReason')
				}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<Fragment>
				<div className="columns">
					<div className="column is-full">
						<div className="field has-text-left">
							<label className="subtitle is-7">Reason</label>
							<div className="control">
								<Dropdown
									enableFixedMode={true}
									value={formikBag.values.cancelReason}
									onValueChange={item => {
										formikBag.setFieldValue('cancelReason', item);
									}}
									options={jobVacancyStore.cancelReasonOptions}
									optionValue={'value'}
								/>
							</div>
						</div>
					</div>
				</div>
				<div className="columns">
					<div className="column is-full">
						<FormField
							className="has-text-left"
							label="Comments"
							field="notes"
							type="textarea"
							placeholder="Comments"
						/>
					</div>
				</div>
			</Fragment>
		);
	}

	async create(values) {
		jobVacancyStore
			.update(this.props.vacancy.id, {
				jobVacancy: {
					cancelReason: values.cancelReason,
					status: this.props.status,
					notes: values.notes
				}
			})
			.then(result => {
				this.resultNotification(result, 'Vacancy', 'Fill Reason');
			});
	}
}
